import * as React from "react";

const LinkTemplate = (value: any,header?: string, command?: any, rowData?: any ) => {
  return (
    <div>
      {header && 
        <span>
          <span className="ml-2 text-sm font-semibold lg:hidden lg:ml-0">
            {header}
          </span>
          <span className="mx-2 lg:hidden">-</span>
        </span>
      }
      <span className="font-semibold text-blue-700 cursor-pointer" onClick={() => command ? command(rowData) : null}>{value}</span>
    </div>
  );
};

export default LinkTemplate;
